// Re-export EditorHost for convenience

/**
 * Status of an individual alt-text element
 */
export let AltImageStatus = /*#__PURE__*/function (AltImageStatus) {
  AltImageStatus["Valid"] = "valid";
  AltImageStatus["Invalid"] = "invalid";
  AltImageStatus["Fixed"] = "fixed";
  AltImageStatus["Decorative"] = "decorative";
  return AltImageStatus;
}({});

/**
 * Props for a single alt-text image rule
 */

/**
 * Translation strings needed by the fixer components
 */

/**
 * BI callback functions - each package provides their own implementation
 */

/**
 * Image URL utility functions
 */

/**
 * Design/styling props that may vary by editor type
 */

/**
 * Task item design props (padding, layout gaps, etc.)
 */

/**
 * Translations for the TaskListItem wrapper
 */

/**
 * Complete context value for the AltTextFixer components
 */
//# sourceMappingURL=index.js.map